import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TravelerGroupModule } from '@dynamic-components/booker-v2/shared/traveler-selector/traveler-group/traveler-group.module';
import {
  JbCloseButtonModule,
  JbErrorModule,
  JbFlyoutModule,
  JbFormFieldContainerModule,
  JbSelectButtonModule,
  JbSrOnlyModule,
} from 'jb-component-library';

import { TravelerSelectorComponent } from './traveler-selector.component';

const MODULES = [
  CommonModule,
  ReactiveFormsModule,
  TravelerGroupModule,
  JbSelectButtonModule,
  JbFlyoutModule,
  JbCloseButtonModule,
  JbFormFieldContainerModule,
  JbErrorModule,
  JbSrOnlyModule,
];

const DECLARATIONS = [TravelerSelectorComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class TravelerSelectorModule {}
